
    import '/vercel/path0/docs/demo/multiple-Portal.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-demo-multiple-portal-demo-multiple-portal"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/vercel/path0/docs/demo/multiple-Portal.md?type=demo')
};